import { render, staticRenderFns } from "./SpecialtySearch.vue?vue&type=template&id=64ecd290&scoped=true"
import script from "./SpecialtySearch.vue?vue&type=script&lang=js"
export * from "./SpecialtySearch.vue?vue&type=script&lang=js"
import style0 from "./SpecialtySearch.vue?vue&type=style&index=0&id=64ecd290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ecd290",
  null
  
)

export default component.exports